import type { BrandTokens } from '../types/theme'

/** Hex colors emitted by the branding editors and safe to interpolate into CSS. */
const HEX_COLOR_RE = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/
const BRAND_TOKEN_KEYS = [
  'primary',
  'secondary',
  'tertiary',
  'background',
  'surface',
  'error',
  'fontColor',
  'sidebar',
  'border',
  'success',
  'warning',
  'neutral',
  'info',
] as const satisfies readonly (keyof BrandTokens)[]

export function toSafeBrandColor(value: unknown): string | null {
  if (typeof value !== 'string') return null

  const color = value.trim()
  return HEX_COLOR_RE.test(color) ? color : null
}

export function sanitizeBrandTokens(tokens: Partial<BrandTokens>): Partial<BrandTokens> {
  const sanitized: Partial<BrandTokens> = {}

  for (const key of BRAND_TOKEN_KEYS) {
    const color = toSafeBrandColor(tokens[key])
    if (color) sanitized[key] = color
  }

  return sanitized
}
